import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as GearIcon } from 'assets/icons/gear_icon.svg';
import { Popover } from 'antd';
import { formattedNumber, validAFM } from 'utils';
import find from 'lodash/find';
import findLast from 'lodash/findLast';
import isEmpty from 'lodash/isEmpty';
import { useSelector, useDispatch } from 'react-redux';
import { updateFormField, getProjectPlanInfo} from 'store/forms/actions';
import { ReactComponent as Info } from 'assets/icons/info-icon.svg';

const Sorefsis = () => {

  const projectPlanInfo = useSelector(state => state.forms.projectPlanInfo);
  const dispatch = useDispatch();

  const sorefsisResponse = !isEmpty(projectPlanInfo) ? projectPlanInfo : [];

  const projectPlans = sorefsisResponse.projectPlans
    ? sorefsisResponse.projectPlans.projectPlan
    : [];
  const messages = sorefsisResponse.messages
    ? sorefsisResponse.messages.message
    : [];

  const [noBusinessPlans, setNoBusinessPlans] = useState(true);
  const [messageDescription, setMessageDescription] = useState('');
  const [popoverMessage, setPopoverMessage] = useState('');
  const abiVat = useSelector(state => state.forms.carrier.abiVat)
  const sorefsisVat = abiVat;
  const mainKAD = useSelector(state => state.forms.carrier.mainKAD);


  useEffect (() => {

    if (validAFM(sorefsisVat))
    dispatch(
    getProjectPlanInfo(sorefsisVat, mainKAD) 
      );
    
  },[sorefsisVat])



  useEffect(() => {
    if (!isEmpty(projectPlanInfo)) {
      let totalAmount = 0
      if(!isEmpty(projectPlanInfo.projectPlans)) {
        projectPlanInfo.projectPlans.projectPlan.map((value)=>{
          for (let stateAid of value.projectPlanInfo.stateAids.stateAid) {
            totalAmount += stateAid["aidAmount"]
          }
        })
      }
      dispatch(updateFormField({
        group: 'carrier',
        key: 'totalAmountSorefsis',
        value: totalAmount
      }))
      if (find(messages, { messageCode: -4 })) {
        setNoBusinessPlans(true);
        setMessageDescription(
          'Στην Επιχείρηση δεν έχει εντοπιστεί κάποια κρατική ενίσχυση μέσω του Πληροφοριακού Συστήματος Σώρευσης την τελευταία τριετία');
        setPopoverMessage(findLast(messages, { messageCode: 0 })
          .messageDescription.split(']')
          .shift()
          .replace('[', ''));
        //dispatch(showSorefsisError(true))
      } else if (find(messages, { messageCode: -1 })) {
        setNoBusinessPlans(true);
        setMessageDescription(find(messages, { messageCode: -1 })
          .messageDescription.split(']')
          .pop());
        //dispatch(showSorefsisError(true))
        } else if (find(messages, { messageCode: 0 })) {
        setNoBusinessPlans(false);
        setPopoverMessage(findLast(messages, { messageCode: 0 })
          .messageDescription.split(']')
          .shift()
          .replace('[', ''));
        //dispatch(showSorefsisError(false))
      }
    }
  }, [projectPlanInfo, messages]);
  
  const sorefsisPopoverContent = (
    <span>
      Τα στοιχεία προέρχονται από το σύστημα <b>sorefsis</b>, με τελευταία
      ενημέρωση <b>{popoverMessage}</b>
    </span>
  );
  return (
    <div className="sorefsisContainer">
      <div className="gearIcon">
        <GearIcon color="#003375"/>
      </div>
      <div className="sorefsisContent">
        <span className="color-blue-3 text-bold font-size-24">
          Έλεγχος Σώρευσης
        </span>
        <Popover
          placement="topLeft"
          classname="sorefsisPopover"
          content={sorefsisPopoverContent}
        >
          <Info className="infoIcon" />
        </Popover>
        </div>
        <p className='sorefsis-subtitle'>
                  Σύμφωνα με το Πληροφοριακό Σύστημα Σώρευσης Κρατικών Ενισχύσεων (Sorefsis.gr) την τελευταία τριετία έχετε λάβει τις παρακάτω ενισχύσεις:
        </p>
        <div className="sorefsisInnerContent">
        {!noBusinessPlans && !isEmpty(projectPlans)&& (
          <div className="sorefsisItemContainer">
            <ul>
            {projectPlans.map(function (value, index) {
              return (
                <li className='sorefsisList'>
                <span className="ml-1 sorefsisItem">
                  Κωδικός Σώρευσης:{value.projectPlanInfo.commonCode}, ΕΣΠΑ{' '}
                  {value.projectPlanInfo.proposalCode} “
                  <b>{value.projectPlanInfo.proposalTitle}”,&nbsp;</b>
                  {formattedNumber(value.projectPlanInfo.amountTotal)} €,
                  Κατάσταση: <b>{value.projectPlanInfo.status}</b>
                </span>
                </li>
              );
            })}
            </ul>
          </div>
        )}
        {noBusinessPlans && (
          <div className="sorefsisItem">{messageDescription}</div>
        )}
      </div>
    </div>
  );
};

Sorefsis.propTypes = {
  projectPlanInfo: PropTypes.object,
};

export default Sorefsis;